import toBrl from '@utils/format_currency';

function priceFormat(pricingSchema, unit) {
  switch (pricingSchema.schema_type) {
    case 'Preço fixo':
      return toBrl(pricingSchema.price);
    case 'Preço fixo com quantidade':
      return `${toBrl(pricingSchema.price)} / ${unit || 'unidade'}`;
    default:
      return 'Variável';
  }
}

export default priceFormat;
